export const TABLET_MIN_WIDTH = 768;
export const TABLET_MAX_WIDTH = 1023;

/** media features for media queries for vanilla-extract */
export const mq = {
  portrait: '(orientation: portrait)',
  landscape: '(orientation: landscape)',
  maxWidth: (width: number) => `(max-width: ${width}px)`,
  minWidth: (width: number) => `(min-width: ${width}px)`,
  minHeight: (height: number) => `(min-height: ${height}px)`,
  maxHeight: (height: number) => `(max-height: ${height}px)`,
  supportsHover: '(hover: hover) and (pointer: fine)',
  narrowScreenPortrait: 'screen and (max-aspect-ratio: 1000/1900) and (orientation: portrait)',
};
